// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_qAi","cls2":"FeedbackModal-cls2_zQf FeedbackModal-cls1_qAi"};